<template>
    <li> 
        <div v-for="submenuQueMePertenece in submenu.SubmenusQueMePertenecen" v-bind:key="submenuQueMePertenece.SubmenuId" >
            <a v-if="submenuQueMePertenece.EsDescarga == true && submenuQueMePertenece.SeMuestraEnVisor == false" v-on:click="AbrirDocumento(submenuQueMePertenece.RutaParaAccesar, '_self');" class="dropdown-item" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <a v-else-if="submenuQueMePertenece.EsDescarga == true && submenuQueMePertenece.SeMuestraEnVisor == true" v-on:click="AbreElVisor(submenuQueMePertenece.RutaParaAccesar);" class="nav-link" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <a v-else-if="submenuQueMePertenece.RutaParaAccesar != null && submenuQueMePertenece.RutaParaAccesar.includes('http')" class="dropdown-item" v-on:click="AbrirDocumento(submenuQueMePertenece.RutaParaAccesar, '_blank');" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</a>
            <router-link v-else-if="submenuQueMePertenece.RutaParaAccesar != null" :to="submenuQueMePertenece.RutaParaAccesar" class="dropdown-item" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}</router-link>
            <a v-else class="dropdown-item dropdown-toggle" v-on:click="submenuQueMePertenece.Mostrar = !submenuQueMePertenece.Mostrar;" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }"><i class="fas fa-circle"></i>{{submenuQueMePertenece.Titulo}}<span class="fas fa-caret-down acomodoDeCaret" /></a>
            <div v-if="submenuQueMePertenece.SubmenusQueMePertenecen.length > 0 && submenuQueMePertenece.Mostrar == true" class="dropdown-menu">
              <SubmenusQueMePertenecen :submenu="submenuQueMePertenece"></SubmenusQueMePertenecen>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'submenu',
    props: {
        submenu: Object
    }, 
    components: {
      SubmenusQueMePertenecen: () => import('./Submenus.vue')
    }, 
    methods: {
        AbrirDocumento: function(vinculo, formaDeApertura) {
          
            window.open(vinculo, formaDeApertura);
        },
        AbreElVisor: function(vinculo) {
          
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
        }
    }
}
</script>

<style scoped>
i {
  font-size: 6px;
  padding-right: 10px;
}

@media (max-width: 768px) {
  li {
      font-size: .7rem !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/MenuIzquierda/Submenus.vue